import { LeftOutlined, RightOutlined, UserOutlined } from '@ant-design/icons';
import { Layout, Menu, Button, Space, Dropdown, message } from 'antd';
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useModal } from '@ebay/nice-modal-react';
import LoginModal from './components/LoginModal';
import { menus } from './const';
import { toggleButtonStyle } from './style';
import {
    DistributionContextProvider,
    useDistributionContext,
} from './contexts/DistributionContext';

const { Sider, Content, Header } = Layout;

const items = menus.map((item) => ({
    label: item.label,
    key: item.key,
    icon: item.icon,
}));

const DistributionContent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const loginModal = useModal(LoginModal);
    const { triggerRefresh } = useDistributionContext();
    const [collapsed, setCollapsed] = useState(false);
    const [selectedKeys, setSelectedKeys] = useState(['myPromotion']); // 默认选中"我的推广"
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [username, setUsername] = useState('');

    // 检查token
    const checkAuth = () => {
        try {
            const userInfo = localStorage.getItem('CommissionUserInfo');
            if (userInfo) {
                const parsed = JSON.parse(userInfo);
                if (parsed && parsed['Commission-Token']) {
                    setIsAuthenticated(true);
                    setUsername(parsed.username || '');
                    return true;
                }
            }
        } catch (error) {
            console.error('解析CommissionUserInfo失败:', error);
        }
        setIsAuthenticated(false);
        setUsername('');
        return false;
    };

    // 路由保护和认证检查
    useEffect(() => {
        checkAuth();
    }, []);

    // 根据当前路由设置选中的菜单项
    useEffect(() => {
        const currentPath = location.pathname;
        // 从路径中提取菜单key，例如 /distribution/baseInfo -> baseInfo
        const pathSegments = currentPath.split('/');
        const currentKey = pathSegments[pathSegments.length - 1];

        // 检查是否是有效的菜单key
        const validKey = menus.find((menu) => menu.key === currentKey);
        if (validKey) {
            setSelectedKeys([currentKey]);
        } else {
            // 如果当前路径不匹配任何菜单项，默认重定向到"我的推广"
            if (currentPath === '/distribution' || currentPath === '/distribution/') {
                navigate('/distribution/myPromotion', { replace: true });
            }
        }
    }, [location.pathname, navigate]);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const handleMenuClick = (item) => {
        const { key } = item;
        setSelectedKeys([key]);
        navigate(`/distribution/${key}`);
    };

    // 打开登录弹窗
    const handleOpenLogin = () => {
        loginModal
            .show()
            .then(() => {
                // 登录成功后，重新检查认证状态
                checkAuth();
                // 触发自定义事件，通知其他组件localStorage已更新
                window.dispatchEvent(new Event('commissionUserInfoUpdated'));
                // 根据当前子路由，触发对应的数据刷新
                const currentPath = location.pathname;
                const pathSegments = currentPath.split('/');
                const currentKey = pathSegments[pathSegments.length - 1];
                // 如果当前路由是有效的菜单key，触发刷新
                const validKey = menus.find((menu) => menu.key === currentKey);
                if (validKey) {
                    triggerRefresh(currentKey);
                }
            })
            .catch(() => {
                // 用户关闭弹窗
            });
    };

    // 退出登录
    const handleLogout = () => {
        localStorage.removeItem('CommissionUserInfo');
        setIsAuthenticated(false);
        setUsername('');
        message.success('退出登录成功');
    };

    // 用户下拉菜单项
    const userMenuItems = [
        {
            key: 'logout',
            label: '退出登录',
            onClick: handleLogout,
        },
    ];

    return (
        <Layout style={{ position: 'relative' }}>
            <Sider theme="light" collapsed={collapsed}>
                <Menu items={items} onClick={handleMenuClick} selectedKeys={selectedKeys}></Menu>
                {/* 展开/收起按钮 */}
                <div style={toggleButtonStyle} onClick={toggleCollapsed}>
                    {collapsed ? (
                        <RightOutlined style={{ fontSize: '12px' }} />
                    ) : (
                        <LeftOutlined style={{ fontSize: '12px' }} />
                    )}
                </div>
            </Sider>
            <Layout>
                <Header
                    style={{
                        background: 'transparent',
                        padding: '0 24px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    {username && (
                        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
                            <span style={{ cursor: 'pointer', userSelect: 'none' }}>
                                <UserOutlined style={{ marginRight: '8px' }} />
                                {username}
                            </span>
                        </Dropdown>
                    )}
                </Header>
                <Content>
                    <Outlet />
                </Content>
            </Layout>
            {/* 未认证时的遮罩层 */}
            {!isAuthenticated && (
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.45)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: '40px',
                            borderRadius: '8px',
                            textAlign: 'center',
                        }}
                    >
                        <div style={{ marginBottom: '24px', fontSize: '16px', color: '#333' }}>
                            请登录后访问
                        </div>
                        <Button type="primary" size="large" onClick={handleOpenLogin}>
                            登录
                        </Button>
                    </div>
                </div>
            )}
        </Layout>
    );
};

const Distribution = () => {
    return (
        <DistributionContextProvider>
            <DistributionContent />
        </DistributionContextProvider>
    );
};

export default Distribution;
